"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clerk = exports.createClerkClient = exports.clerkClient = exports.SIGN_UP_URL = exports.SIGN_IN_URL = exports.IS_SATELLITE = exports.PROXY_URL = exports.DOMAIN = exports.PUBLISHABLE_KEY = exports.FRONTEND_API = exports.SECRET_KEY = exports.API_KEY = exports.API_VERSION = exports.API_URL = exports.JS_VERSION = void 0;
const tslib_1 = require("tslib");
const backend_1 = require("@clerk/backend");
Object.defineProperty(exports, "Clerk", { enumerable: true, get: function () { return backend_1.Clerk; } });
exports.JS_VERSION = process.env.CLERK_JS_VERSION || '';
exports.API_URL = process.env.CLERK_API_URL || 'https://api.clerk.dev';
exports.API_VERSION = process.env.CLERK_API_VERSION || 'v1';
exports.API_KEY = process.env.CLERK_API_KEY || '';
exports.SECRET_KEY = process.env.CLERK_SECRET_KEY || '';
exports.FRONTEND_API = process.env.NEXT_PUBLIC_CLERK_FRONTEND_API || '';
exports.PUBLISHABLE_KEY = process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY || '';
exports.DOMAIN = process.env.NEXT_PUBLIC_CLERK_DOMAIN || '';
exports.PROXY_URL = process.env.NEXT_PUBLIC_CLERK_PROXY_URL || '';
exports.IS_SATELLITE = process.env.NEXT_PUBLIC_CLERK_IS_SATELLITE === 'true' || false;
exports.SIGN_IN_URL = process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL || '';
exports.SIGN_UP_URL = process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL || '';
const clerkClient = (0, backend_1.Clerk)({
    apiKey: exports.API_KEY,
    secretKey: exports.SECRET_KEY,
    apiUrl: exports.API_URL,
    apiVersion: exports.API_VERSION,
    // TODO: Fetch version from package.json
    userAgent: '@clerk/nextjs',
    proxyUrl: exports.PROXY_URL,
    domain: exports.DOMAIN,
    isSatellite: exports.IS_SATELLITE,
});
exports.clerkClient = clerkClient;
const createClerkClient = backend_1.Clerk;
exports.createClerkClient = createClerkClient;
tslib_1.__exportStar(require("@clerk/backend"), exports);
